export const GetActiveLink = (location) => {
  switch (location) {
    case "/":
      return "Reports";
    case "/products":
      return "Products";

    case "/users":
      return "User";
    case "/productions":
      return "Productions";
    case "/packagin-material":
      return "Packaging Material";
    case "/factory":
      return "Factory";
    case "/leaf":
      return "Leaf";
    case "/vendor-payment":
      return "Vendor Payment";
    case "/vendor":
      return "Vendor";
    case "/labourcost":
      return "Labour Cost";
    case "/subquality":
      return "Sub Quality";
    case "/operator":
      return "Operator";
    case "/leafwarehouse":
      return "Leaf Ware House";
    case "/cartoontype":
      return "Cartoon Type";
    case "/plastictype":
      return "Plastic Type";
    case "/production":
      return "Production";
    case "/mold":
      return "Mold";
    case "/cartoonstock":
      return "Cartoon Stock";
    case "/plasticstock":
      return "Plastic Stock";
    case "/leafstock":
      return "Leaf Stock";
    case "/stickerstock":
      return "Sticker Stock";
    case "/cartoonwithdraw":
      return "Cartoon Withdraw";
    case "/plasticwithdraw":
      return "Plastic Withdraw";
    default:
      return "Products";
  }
};
